import { render, staticRenderFns } from "./summernote.vue?vue&type=template&id=052e95be&"
import script from "./summernote.vue?vue&type=script&lang=ts&"
export * from "./summernote.vue?vue&type=script&lang=ts&"
import style0 from "./summernote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports